import {useQuery} from 'react-query';
import {client} from './ApiClient';
import {mapServiceUrls} from '../Helpers/Functions';

export interface CustomerWebSummary {
	Id: number;
	Uid: string;
	Code: string;
	FirstName: string;
	LastName: string;
	EmailAddress: string;
	Phone1: string;
	MobilePhone: string;
	CompanyName: string;
}

const getResolvedCustomerSummary = (
	key: unknown,
	urls: { LoyaltyEngineApiUrl: string },
	domain: string,
	deviceCode: string,
	customerToken: string
) => {
	return client(
		urls.LoyaltyEngineApiUrl,
		`api/v4/${domain}/${deviceCode}/customers/resolvedsummary?customerToken=${encodeURIComponent(customerToken)}`
	);
};

export default function useResolvedCustomerSummary(
	urls: unknown,
	domain: string,
	deviceCode: string,
	customerToken: string | null
) {
	const {status, data, error, isFetching} = useQuery(
		['ResolvedCustomerSummary', customerToken],
		(key) =>
			getResolvedCustomerSummary(
				key,
				mapServiceUrls(urls) as { LoyaltyEngineApiUrl: string },
				domain,
				deviceCode,
				customerToken as string
			),
		{
			enabled: !!urls && !!domain && !!deviceCode && !!customerToken,
			staleTime: 1000 * 60 * 5,
			retry: false
		}
	);

	const customerSummary: CustomerWebSummary | undefined = data?.data;

	return {
		customerSummaryStatus: status,
		customerSummary,
		customerSummaryError: error,
		isCustomerSummaryFetching: isFetching
	};
}
